var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.isDialogActive,"persistent":""}},[_c('v-card',{staticClass:"pa-6",attrs:{"color":"primary"}},[_c('v-card-text',[_c(_vm.dialog.component,{tag:"component"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }